import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconShield: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 2.33333L12.3333 4.06667V7.53333C12.3333 10.3333 10.4667 12.1333 8 13.1333C5.53333 12.1333 3.66667 10.3333 3.66667 7.53333V4.06667L8 2.33333Z"
    />
  </svg>
);

export {
  IconShield,
};
